import { useParams  } from 'react-router-dom';
import Login from '../auth/Login';
import Register from '../auth/Register';
import Cell from '../components/Cell';

function Authent({setCurrentUser}) {

    const mode = useParams().type;

    const getBloc = () => {
        if (mode === 'login') {
            return (
                <div className='login'>
                    <h1>Vous avez déjà un compte ? </h1>
                    <Login setCurrentUser={setCurrentUser} />
                </div>
            )
        } 
        else {
            return (
                <div className='register'>
                    {/**/}<h1>Pas de compte ? </h1>
                    <Register setCurrentUser={setCurrentUser} />
                </div>
            )
        }
    }
    const bloc = getBloc();

    // Login or Register
    return (
        <>
            <div id='motus_title'>
                <Cell
                key={'1'}
                letter={'M'}
                status={'present'}
                />
                <Cell
                key={'2'}
                letter={'O'}
                status={'absent'}
                />
                <Cell
                key={'3'}
                letter={'M'}
                status={'present'}
                />
                <Cell
                key={'4'}
                letter={'O'}
                status={'absent'}
                />
                <Cell
                key={'5'}
                letter={'M'}
                status={'correct'}
                />
                <Cell
                key={'6'}
                letter={'O'}
                status={'correct'}
                />
                <Cell
                key={'7'}
                letter={'T'}
                status={'correct'}
                />
                <Cell
                key={'8'}
                letter={'U'}
                status={'correct'}
                />
                <Cell
                key={'9'}
                letter={'S'}
                status={'correct'}
                />
            </div>
            <div className='cleared'></div>
            
            {bloc}
        </>
    );
}

export default Authent;